import React, { Component } from 'react';  
import Util from "../../util.js";
import { Slider, Toast, Picker, List } from 'antd-mobile/lib';
import { protocolCode } from '../../BankCode'
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import { connect } from 'react-redux';
import { yljycbMoney, yqyljyMoney, yljyAge, yqyljySliderVal, jySchoolType } from "../../action/investmentAction.js";

let interVal = null;

class EducationCalculator extends Component { 
  state = {
    theMoney: this.props.yljycbMoney,
    theOutMoney: this.props.yqyljyMoney,
    childAge: this.props.yljyAge,
    sliderVal: this.props.yqyljySliderVal,
    thunkIcon: false,
    loadingArr: [require("../../img/theLoading1.png"),
    require("../../img/theLoading2.png"),
    require("../../img/theLoading3.png"),
    require("../../img/theLoading4.png"),
    require("../../img/theLoading5.png"),
    require("../../img/theLoading6.png"),
    require("../../img/theLoading7.png"),
    require("../../img/theLoading8.png"),
    require("../../img/theLoading9.png"),
    require("../../img/theLoading10.png"),
    require("../../img/theLoading11.png"),
    require("../../img/theLoading12.png"),
    require("../../img/theLoading13.png"),
    require("../../img/theLoading14.png"),
    require("../../img/theLoading15.png"),
    require("../../img/theLoading16.png"),
    require("../../img/theLoading17.png"),
    require("../../img/theLoading18.png"),
    require("../../img/theLoading19.png"),
    require("../../img/theLoading20.png"),
    require("../../img/theLoading21.png"),
    require("../../img/theLoading22.png"),
    require("../../img/theLoading23.png"),
    require("../../img/theLoading24.png"),
    require("../../img/theLoading25.png")],
    loadingIcon: "",
    schoolType: this.props.jySchoolType
  } 

  componentWillMount() {
    document.getElementsByTagName('title')[0].innerHTML = "教育智能规划";
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "进入"]);
  }

  componentWillUnmount() {
    clearInterval(interVal);
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "auto";
    obj.style.overflowY = "auto";
    obj.removeEventListener("touchmove", this.touchMove, false);
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "退出"]);
  }
  touchMove = (event) => {
    event.preventDefault();
  }
  changeTheMoney = (event) => {
    let { dispatch } = this.props; 
    this.setState({
      theMoney :event.target.value
    })
    dispatch(yljycbMoney(event.target.value));
  }

  changeTheOutMoney = (value) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "输入教育金"]);
    let { dispatch } = this.props; 
    let { schoolType } = this.state;
    if(schoolType == "国内院校") {
      if(value > 30000 && value <= 40000) {
        let a = (50000 - 30000) / (10000 / 1000);
        let b = (value - 30000) / 1000;
        this.setState({
          sliderVal: a * b + 30000
        });
        dispatch(yqyljySliderVal(a * b + 30000));
      }else if(value > 40000 && value <= 50000) {
        let a = (100000 - 50000) / (10000 / 1000);
        let b = (value - 40000) / 1000;
        this.setState({
          sliderVal: a * b + 50000
        });
        dispatch(yqyljySliderVal(a * b + 50000));
      }else if(value > 50000 && value <= 60000) {
        let a = (200000 - 100000) / (10000 / 1000);
        let b = (value - 50000) / 1000;
        this.setState({
          sliderVal: a * b + 100000
        });
        dispatch(yqyljySliderVal(a * b + 100000));
      }else {
        this.setState({
          sliderVal: value
        });
        dispatch(yqyljySliderVal(value));
      }
    }else if(schoolType == "国外院校") {
        this.setState({
          sliderVal: value
        });
        dispatch(yqyljySliderVal(value));
    }
    this.setState({
      theOutMoney: value
    });
    dispatch(yqyljyMoney(value));
  }

  goBack = () => {
    hashHistory.goBack();
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "回退"]);
  }

  changeAge = (value) => {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "选择年龄"]);
    let { dispatch } = this.props; 
    this.setState({
      childAge: value[0]
    });
    dispatch(yljyAge(value[0]));
  }

  goResult = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "计算结果"]);
    let { childAge, theMoney, sliderVal } = this.state;
    let { school } = this.props.location.state;
    let regMoney = /^(([1-9]\d{0,9})|0)(\.\d{1,2})?$/;
    let dlValue;
    let pValue;
    let studyMoney = sliderVal;
    if(!regMoney.test(theMoney)) {
      Toast.info( "请输入有效金额", 2);
      return;
    }
    if(school == "初中") {
      dlValue = 12;
      pValue = 3;
    }else if(school == "高中") {
      dlValue = 15;
      pValue = 3;
    }else if(school == "大学") {
      dlValue = 18;
      pValue = 4;
    }
    this.getYearGap(childAge, studyMoney, theMoney, dlValue, pValue);
  }

  getYearGap = (A, N, S, DL, P) => {
    let obj = document.getElementsByTagName("html")[0];
    obj.style.overflowY = "hidden";
    obj.style.overflowY = "hidden";
    obj.addEventListener("touchmove", this.touchMove, false);
    let { school } = this.props.location.state;
    this.setState({
      thunkIcon: true,
      loadingIcon: this.state.loadingArr[0]
    });
    let r = 0.03;
    let r2 = 1/(1+r);
    let ST = S * Math.pow((r+1), (DL-A));
    let N1 = ST / ((1-Math.pow((r2), P)) / (1-(r2)));
    let count = 0;
    interVal = setInterval(() => {
      if(count == 49) {
        clearInterval(interVal);
        this.setState({
          thunkIcon: false
        });
        let obj = document.getElementsByTagName("html")[0];
        obj.style.overflowY = "auto";
        obj.style.overflowY = "auto";
        obj.removeEventListener("touchmove", this.touchMove, false);
        hashHistory.push({
          pathname: "/educationCalculatorResult",
          state: {
            theParams: {
              actual: N1.toFixed(2), 
              gap: (N-N1).toFixed(2),
              theMoney: Util.parsePrice(N, false),
              theAge: A,
              school: school,
              schoolType: this.state.schoolType,
              theOutMoney: this.state.sliderVal
            }
          }
        }); 
      }else {
        count++;
        if(count > 24) {
          this.setState({
            loadingIcon: this.state.loadingArr[count - 25]
          });
        }else {
          this.setState({
            loadingIcon: this.state.loadingArr[count]
          });
        }
      }
    }, 100);
  }
  goRule = () => {
    window._czc.push(["_trackEvent", "华夏财富H5", "教育智能规划", "计算规则"]);
    let code=protocolCode["教育计算器规则"];
    hashHistory.push({
        pathname:'/WebView',
        state:{
          name: "教育计算器规则",
          code: code
        },
        query: {
          code: code
        }
    })
  }

  focusTheMoney = () => {
    let { dispatch } = this.props;
    if(this.state.theMoney == "0") {
      this.setState({
        theMoney: ""
      })
      dispatch(yljycbMoney(""));
    }
  }
  blurTheMoney = () => {
    let { dispatch } = this.props;
    if(this.state.theMoney == "") {
      this.setState({
        theMoney: "0"
      })
      dispatch(yljycbMoney("0"));
    }
  }
  changeMoney = (event) => {
    let reg = /^[0-9]*$/;
    let { dispatch } = this.props;
    if(event.target.value.length <= 7 && reg.test(Util.priceParse(event.target.value))) {
      this.setState({
        sliderVal: Util.priceParse(event.target.value)
      });
      dispatch(yqyljySliderVal(Util.priceParse(event.target.value)));
    }
  }

  changeSchoolType = (school) => {
    let _this = this;
    let { dispatch } = this.props;
    dispatch(jySchoolType(null));
    _this.setState({
      schoolType: null
    });
    setTimeout(() => {
      dispatch(jySchoolType(school));
      dispatch(yqyljyMoney(school == "国内院校" ? 20000 : 100000));
      dispatch(yqyljySliderVal(school == "国内院校" ? 20000 : 100000));
      _this.setState({
        schoolType: school,
        sliderVal: school == "国内院校" ? 20000 : 100000,
        theOutMoney: school == "国内院校" ? 20000 : 100000
      })
    });
    
  }

  render() { 
    let { school } = this.props.location.state;
    let { theMoney, childAge, theOutMoney, sliderVal, schoolType } = this.state;
    let arrList = [""];
    let pickerData;
    if(school == "初中") {
      pickerData = [{value: -1, label: -1}, {value: 0, label: 0}, {value: 1, label: 1}, {value: 2, label: 2}, {value: 3, label: 3}, {value: 4, label: 4}, {value: 5, label: 5}, {value: 6, label: 6}, {value: 7, label: 7}, {value: 8, label: 8}, {value: 9, label: 9}, {value: 10, label: 10}, {value: 11, label: 11}];
    }else if(school == "高中") {
      pickerData = [{value: -1, label: -1}, {value: 0, label: 0}, {value: 1, label: 1}, {value: 2, label: 2}, {value: 3, label: 3}, {value: 4, label: 4}, {value: 5, label: 5}, {value: 6, label: 6}, {value: 7, label: 7}, {value: 8, label: 8}, {value: 9, label: 9}, {value: 10, label: 10}, {value: 11, label: 11}, {value: 12, label: 12}, {value: 13, label: 13}, {value: 14, label: 14}];
    }else if(school == "大学") {
      pickerData = [{value: -1, label: -1}, {value: 0, label: 0}, {value: 1, label: 1}, {value: 2, label: 2}, {value: 3, label: 3}, {value: 4, label: 4}, {value: 5, label: 5}, {value: 6, label: 6}, {value: 7, label: 7}, {value: 8, label: 8}, {value: 9, label: 9}, {value: 10, label: 10}, {value: 11, label: 11}, {value: 12, label: 12}, {value: 13, label: 13}, {value: 14, label: 14}, {value: 15, label: 15}, {value: 16, label: 16}, {value: 17, label: 17}];
    }
    return (  
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader bgChange">
            <div>
              <img onClick={this.goBack} src={require("../../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>教育智能规划</span>
            </div>
            <div>
              <span onClick={this.goRule}>计算规则</span>
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent" style={{paddingBottom: 20}}>
          <div  className="bgChange2" style={{backgroundSize: "cover",width: window.winWidth, height: "auto", paddingBottom: 20, paddingTop: 20}}>
            <div style={{
              width: window.winWidth,
              paddingLeft: 13,
              paddingRight: 13,
              WebkitFlexDirection: "row",
              WebkitJustifyContent: "space-between",
              WebkitAlignItems: "center",
              display: "-webkit-flex"
            }}>
              <img
              style={{width: 63, height: 63}}
              src={require("../../img/jqrIcon.png")}
              />
              <div style={{paddingRight: 10, paddingTop: 10, paddingBottom: 10, paddingLeft: 15, backgroundColor: "rgba(0, 0, 0, 0.2)", width: window.winWidth-96, borderRadius: 10}}>
                <span style={{
                  color: "#fff",
                  lineHeight: "16px",
                  fontSize: 13
                }}>输入子女年龄、教育阶段和当前教育金储备，算算您的教育金缺口：</span>
              </div> 
            </div>
          </div>
          <div>
            <div className="pickerBox3" style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(235, 238, 240)",
              position: "relative"
            }}>
              <Picker value={[childAge]} title="选择年龄" extra={childAge} data={pickerData} onChange={this.changeAge} cols={1} className="forss">
                <List.Item arrow="horizontal">孩子年龄</List.Item>
              </Picker>
              <span style={{fontSize: 13, color: "#000", position: "absolute", right: 45, top: 15}}>
                岁
              </span>
            </div>
            <div style={{
              display: "-webkit-flex",
              height: 45,
              backgroundColor: "#fff",
              paddingLeft: 13,
              paddingRight: 13,
              WebkitAlignItems: "center",
              WebkitFlexDirection: "row",
              borderBottom: "1px solid rgb(235, 238, 240)"
            }}>
              <span style={{
                color: "#000",
                fontSize: "13px",
                width:"50%"
              }}>
                当前教育储备金
              </span>
              <div style={{paddingRight: 32, display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitAlignItems: "center"}}>
                <input autocomplete="off"
                style={{
                  height: 40,
                  width:"100%",
                  fontSize: 13,
                  color: "#3a3e47",
                  textAlign: 'right'
                }}
                value={theMoney}
                onChange={this.changeTheMoney}
                placeholder="请输入金额"
                onFocus={this.focusTheMoney}
                onBlur={this.blurTheMoney}
                />
                <span style={{fontSize: 13, color: "#000", paddingLeft: 5}}>
                  元
                </span>
              </div>
            </div>
          </div>
          <div style={{paddingTop: 20, paddingBottom: 20, paddingLeft: 13, paddingRight: 13, backgroundColor: "#fff"}}>
            <div style={{display: "-webkit-flex", WebkitFlex: 1, WebkitFlexDirection: "row", WebkitJustifyContent: "center", paddingBottom: 20}}>
              <div onClick={() => {this.changeSchoolType("国内院校")}} style={{borderStyle: "solid", borderWidth: 1, borderColor: schoolType == "国内院校" ? "#fe4920" : "#dcdcdc", borderRadius: 50, width: 100, height: 25, marginRight: 10}}>
                <div style={{height: "100%", display: "-webkit-flex",WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <span style={{color: schoolType == "国内院校" ? "#fe4920" : "#3a3e47", fontSize: 12}}>国内院校</span>
                </div>
              </div>
              <div onClick={() => {this.changeSchoolType("国外院校")}} style={{borderStyle: "solid", borderWidth: 1, borderColor: schoolType == "国外院校" ? "#fe4920" : "#dcdcdc", borderRadius: 50, width: 100, height: 25, marginRight: 10}}>
                <div style={{height: "100%", display: "-webkit-flex",WebkitFlex: 1, WebkitJustifyContent: "center", WebkitAlignItems: "center"}}>
                  <span style={{color: schoolType == "国外院校" ? "#fe4920" : "#3a3e47", fontSize: 12}}>国外院校</span>
                </div>
              </div>
            </div>
            <div style={{WebkitFlexDirection: 'row', WebkitAlignItems: "center", height: 50, display: "-webkit-flex", WebkitJustifyContent: "center"}}>
              <span style={{color: "#3a3e47", fontSize: 12}}>预计每年教育支出</span><div style={{marginTop: -15, borderBottom: "1px solid #fa063a"}}><input autocomplete="off" type="text" onChange={this.changeMoney} style={{color: "#fa063a", fontSize: 22, width: 90, padding: 0, textAlign: "center"}} value ={Util.parsePrice(sliderVal, false) == 0.00 ? "0" : Util.parsePrice(sliderVal, false)} /></div><span style={{color: "#3a3e47", fontSize: 12}}>元</span>
            </div>
            <div style={{paddingTop: 10, textAlign: "center"}}>
              {
                schoolType == "国内院校" ?
                <Slider trackStyle={{backgroundColor: "transparent", width: window.winWidth - 34}} railStyle={{backgroundColor: "transparent"}} handleStyle={{backgroundColor: "transparent", border: 0, "boxShadow": "none", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: 30, width: 25, border: 0, backgroundImage: `url(${require("../../img/huakuai.png")})`}} step={1000} defaultValue={theOutMoney} min={0} max={60000} onChange={this.changeTheOutMoney} />
                :
                schoolType == "国外院校" ? 
                <Slider trackStyle={{backgroundColor: "transparent", width: window.winWidth - 34}} railStyle={{backgroundColor: "transparent"}} handleStyle={{backgroundColor: "transparent", border: 0, "boxShadow": "none", backgroundSize: "contain", backgroundRepeat: "no-repeat", backgroundPosition: "center", height: 30, width: 25, border: 0, backgroundImage: `url(${require("../../img/huakuai.png")})`}} step={1000} defaultValue={theOutMoney} min={0} max={600000} onChange={this.changeTheOutMoney} />
                :
                null
              }
              <img
              src={require("../../img/huatiao7.png")}
              style={{width: window.winWidth - 49, marginTop: 25}}
              />
              {
                  arrList.map((data, key) => {
                    if(school == "初中") {
                      if(schoolType == "国内院校") {
                        return (
                          <div key={0} style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>1w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>2w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>3w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>5w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>10w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>20w</span>
                          </div>
                        );
                      }else if(schoolType == "国外院校") {
                        return (
                          <div key={0} style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>10w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>20w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>30w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>40w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>50w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>60w</span>
                          </div>
                        );
                      }else {
                        return null;
                      }
                    }else if(school == "高中") {
                      if(schoolType == "国内院校") {
                        return (
                          <div key={0} style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>1w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>2w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>3w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>5w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>10w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>20w</span>
                          </div>
                        );
                      }else if(schoolType == "国外院校") {
                        return (
                          <div key={0} style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>10w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>20w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>30w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>40w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>50w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>60w</span>
                          </div>
                        );
                      }else {
                        return null;
                      }
                    }else if(school == "大学") {
                      if(schoolType == "国内院校") {
                        return (
                          <div key={0} style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>1w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>2w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>3w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>5w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>10w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>20w</span>
                          </div>
                        );
                      }else if(schoolType == "国外院校") {
                        return (
                          <div key={0} style={{margin: "0 auto", width: window.winWidth - 29, WebkitJustifyContent: "space-between", WebkitFlexDirection: "row", display: "-webkit-flex"}}>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>0w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>10w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>20w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>30w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>40w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>50w</span>
                            <span style={{fontSize: 12, color: "#5b6370", width: 30, textAlign: "center"}}>60w</span>
                          </div>
                        );
                      }else {
                        return null;
                      }
                    }
                  })
                }
            </div>
          </div>
          <div
          style={{display: "-webkit-flex", backgroundColor: "#fff", WebkitJustifyContent: "center", WebkitAlignItems: "center", paddingLeft: 13, paddingRight: 13, marginTop: 10, paddingTop: 20, paddingBottom: 20}}
          >
            <span style={{
              color: "#5b6270",
              lineHeight: 1.5,
              display: "block",
              fontSize: "13px"
            }}>
              温馨提示 : 教育储备金是指您当前计划用于子女教育的储备金，一般是指银行存款、补充商业保险等。孩子教育支出一般包括学杂费、兴趣班、生活费等。试算年化收益率仅用于方案试算，不代表某个智投组合的收益表现。
            </span>
          </div>
          <div style={{WebkitJustifyContent: "center", WebkitAlignItems: "center", marginTop: 10, display: "-webkit-flex"}}>
            {
              theMoney != "" && theMoney != null && theMoney != undefined ?
              <div onClick={this.goResult} style={{backgroundColor: "#fa063a", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex"}}>
                <span style={{color: "#fff", fontSize: 14}}>诊断教育投资状况</span>
              </div> :
              <div style={{backgroundColor: "#afb0b2", WebkitJustifyContent: "center", WebkitAlignItems: "center", height: 40, width: window.winWidth - 26, borderRadius: 30, display: "-webkit-flex"}}>
                <span style={{color: "#fff", fontSize: 14}}>诊断教育投资状况</span>
              </div>
            }
          </div>
        </div>
        {
          !this.state.thunkIcon ? null :
          <div style={{position:'fixed', left:0, bottom: 0, width: window.winWidth, backgroundColor: "rgba(0, 0, 0, 0.7)", WebkitJustifyContent: "center", WebkitAlignItems: "center", top: window.navigator.userAgent.indexOf("amcfmapp") > -1 || window.navigator.userAgent.indexOf("hxcfH5WX") > -1 || window.navigator.userAgent.match(/MicroMessenger/i) == "micromessenger" ? 0 : 44, display: "-webkit-flex", WebkitFlexDirection: "column"}}>
            <img
            src={this.state.loadingIcon}
            style={{width: 250, height: 250, marginTop: -80}}
            />
            <span style={{marginTop: 25, fontSize: 18, color: "#fff"}}>运算中...</span>
          </div>
        }
      </div>  
    );  
  }  
}  
  
function mapStateToProps(state, ownProps) {
  return {
    yljycbMoney: state.yljycbMoney,
    yqyljyMoney: state.yqyljyMoney,
    yljyAge: state.yljyAge,
    yqyljySliderVal: state.yqyljySliderVal,
    jySchoolType: state.jySchoolType
  }
}
  
export default connect(mapStateToProps)(EducationCalculator);


// WEBPACK FOOTER //
// ./src/components/recommend/EducationCalculator.js